import { Folder } from '@mui/icons-material';
import { Box, Button, Typography, styled } from '@mui/material';

export const CurrentFolder = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const EllipsisButton = styled(Button)(() => ({
  minWidth: '35px',
  padding: '0',
  height: '20px',
  verticalAlign: 'baseline',
  background: 'transparent',
  '&:hover': {
    background: 'transparent',
  },
}));

export const FolderIcon = styled(Folder)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 45,
}));

export const FolderListThumbnail = styled(Box)(() => ({
  width: 64,
  height: 36,
}));
